/**
 * 菜单
 * */
import { Modal } from 'view-design';
import { getApi, postApi } from '@api/index';
import { INITMENU, setCurrentMenuCrumbs } from '@/store/modules/admin/mutation-types';
import menuLibs from '@/libs/menu';
import { cloneDeep } from 'lodash';
export default {
  namespaced: true,
  state: {
    // 全部的菜单集合
    menu: [],
    // 展开的子菜单 name 集合
    currentMenuCrumbs: []
  },
  getters: {
    getMenu: function getMenu(state) {
      return state.menu;
    }
  },
  mutations: {
    /**
     * @description 设置当前面包屑层级
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    INITMENU: function INITMENU(state, payload) {
      state.menu = payload;
    },
    setCurrentMenuCrumbs: function setCurrentMenuCrumbs(state, names) {
      localStorage.setItem('currentMenuCrumbs', JSON.stringify(names));
      state.currentMenuCrumbs = names;
    }
  },
  actions: {
    setInitMenu: function setInitMenu(_ref, payload) {
      var commit = _ref.commit;
      commit(setCurrentMenuCrumbs, JSON.parse(localStorage.getItem('currentMenuCrumbs'))); // return new Promise(async resolve => {
      //   // store 赋值
      //   state.menu = payload;
      //   // 持久化
      //   // await dispatch('admin/db/set', {
      //   //   dbName: 'sys',
      //   //   path: 'user.info',
      //   //   value: info,
      //   //   user: true
      //   // }, { root: true });
      //   // end
      //   resolve();
      // });

      var param = {
        appCode: CONSTANT.APP_CODE,
        time: new Date().getTime()
      };
      postApi(DYC_URL.umc_getUserMenus, param).then(function (res) {
        if (res.menus && res.menus.length) {
          var menus = menuLibs(res.menus);
          commit(INITMENU, menus);
          sessionStorage.setItem('menuList', JSON.stringify(menus));
        } else {
          Modal.error({
            title: '错误',
            content: '您尚未配置菜单，请联系管理员配置菜单！'
          });
        }
      });
    }
  }
};